export default class PosComponent {

    /**
     *
     * @param selector
     */
    constructor(selector) {
        this.selector = selector;
        this.posSiteLink = $('#pos-site-link');
        this.confirmButton = $('#submit-pos-point');

        this.data = this.initNullPosData();

        this.replacements = {
            'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
            'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N', 'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
        };

        this.expression = /[ąćęłńóśźż]/gi;

        this.initEvents();
    }

    initNullPosData() {
        return {
            pos: {
                pos_id : null
            }
        }
    }

    clearData() {
        this.initNullPosData();
    }

    isNull() {
        return JSON.stringify(this.data) == JSON.stringify(this.initNullPosData());
    }

    getPos() {
        return this.data;
    }

    initEvents() {
        this.selector.on('change', event => this.onChangeHandler(this.selector))
        this.confirmButton.on('click', event => this.onFormSubmitted())
    }

    onFormSubmitted() {
        if(this.isNull()) {
            alert('Należy wybrać salon Aclari');
            return false;
        }
        else {
            const selectedOption =$ ('#basketorder-pos-pos_id option:selected');
            const city = selectedOption.data('city');
            $('.shipping .pos-point .name').html(city.charAt(0).toUpperCase() + city.slice(1));
            $('.shipping .pos-point .address').html(selectedOption.data('address'));
            $('.shipping .self-receive').addClass('hidden');
            $('.shipping .pos-point').removeClass('hidden');
            $('#localPickupModal').modal('hide');
        }
    }

    onChangeHandler() {
        this.data.pos.pos_id = this.selector.val();
        let city = this.selector.find('option:selected').data('city');
        city = city.charAt(0).toLowerCase() + city.slice(1);

        this.posSiteLink.prop('href', `/salon-${this.replacePolishLetters(city)}.html`);
    }

    replacePolishLetters(text) {
        return text.replace(this.expression, (letter) => this.replacements[letter]);
    };

}
